// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3awbe","search":"Settings_search__3JeW2","filter":"Settings_filter__341LR"};